import { Translate } from 'react-redux-i18n'
import { store } from '../../../../../app/store'
import { selectVsics } from '../../../../common/category/store/slice'
import { selectCompanyInfo } from '../../../../companyAnalysis/common/header/companyInfo/store/slice'
import { getDefaultVsic } from '../../../../companyAnalysis/industry/helper'
import { AssetQualityTable } from '../../../../companyAnalysis/industry/industryAnalysis/bank/assetQuality/AssetQualityTable'
import { postAssetQuality } from '../../../../companyAnalysis/industry/industryAnalysis/bank/assetQuality/store/thunk'
import { BusinessGrowthBankTable } from '../../../../companyAnalysis/industry/industryAnalysis/bank/businessGrowth/BusinessGrowthBankTable'
import { getBusinessGrowthBankThunk } from '../../../../companyAnalysis/industry/industryAnalysis/bank/businessGrowth/store/thunk'
import { CapitalAdequacyTable } from '../../../../companyAnalysis/industry/industryAnalysis/bank/capitalAdequacy/CapitalAdequacyTable'
import { postCapitalAdequacy } from '../../../../companyAnalysis/industry/industryAnalysis/bank/capitalAdequacy/store/thunk'
import { EarningQualityTable } from '../../../../companyAnalysis/industry/industryAnalysis/bank/earningQuality/EarningQualityTable'
import { postEarningQuality } from '../../../../companyAnalysis/industry/industryAnalysis/bank/earningQuality/store/thunk'
import { LiquidityTable } from '../../../../companyAnalysis/industry/industryAnalysis/bank/liquidity/LiquidityTable'
import { postLiquidity } from '../../../../companyAnalysis/industry/industryAnalysis/bank/liquidity/store/thunk'
import { CompareIndustry } from '../../../../companyAnalysis/industry/industryAnalysis/bottom/CompareIndustry'
import { DefaultIndustry } from '../../../../companyAnalysis/industry/industryAnalysis/bottom/DefaultIndustry'
import { AssetManagementEfficiencyTable } from '../../../../companyAnalysis/industry/industryAnalysis/corp/assetManagementEfficiency/AssetManagementEfficiencyTable'
import { postAssetManagementEfficiency } from '../../../../companyAnalysis/industry/industryAnalysis/corp/assetManagementEfficiency/store/thunk'
import { BusinessGrowthTable } from '../../../../companyAnalysis/industry/industryAnalysis/corp/businessGrowth/BusinessGrowthTable'
import { postBusinessGrowth } from '../../../../companyAnalysis/industry/industryAnalysis/corp/businessGrowth/store/thunk'
import { LiquiditySolvencyCoverageTable } from '../../../../companyAnalysis/industry/industryAnalysis/corp/liquiditySolvencyCoverage/LiquiditySolvencyCoverageTable'
import { postLiquidityAndSolvencyAndCoverAge } from '../../../../companyAnalysis/industry/industryAnalysis/corp/liquiditySolvencyCoverage/store/thunk'
import { ProfitabilityTable } from '../../../../companyAnalysis/industry/industryAnalysis/corp/profitability/ProfitabilityTable'
import { postProfitability } from '../../../../companyAnalysis/industry/industryAnalysis/corp/profitability/store/thunk'
import GeneralAnalysisExport from '../../../../companyAnalysis/industry/industryAnalysis/generalAnalysis/GeneralAnalysisExport'
import {
  getActivitiesRatioAndRisk,
  getActivitiesRatioAndRiskCompare,
  getCommentary,
  getDistributeScoreChart,
  getDistributeScoreCompareChart,
  getGenericRatioHighlight,
  getIndustryRatioDetail,
  getPerformanMatrixChartData,
  getPerformanMatrixDisplayData,
} from '../../../../companyAnalysis/industry/industryAnalysis/generalAnalysis/store/thunk'
import { SCORE_TABS } from '../../../../companyAnalysis/industry/industryAnalysis/score/constant'
import { selectScoreIndustryAnalysis } from '../../../../companyAnalysis/industry/industryAnalysis/score/store/slice'
import { COMPARE_TYPE } from '../../../../companyAnalysis/industry/industryAnalysis/sectorPerformance/constant'
import SectorPerformanceExport from '../../../../companyAnalysis/industry/industryAnalysis/sectorPerformance/SectorPerformanceExport'
import {
  getFdiDomestic,
  getLargeSme,
  getListedLarge,
} from '../../../../companyAnalysis/industry/industryAnalysis/sectorPerformance/store/thunk'
import { CapitalEarningLeverageTable } from '../../../../companyAnalysis/industry/industryAnalysis/securities/capitalEarningLeverage/CapitalEarningLeverageTable'
import { postCapitalEarningLeverage } from '../../../../companyAnalysis/industry/industryAnalysis/securities/capitalEarningLeverage/store/thunk'
import { FundingLiquidityTable } from '../../../../companyAnalysis/industry/industryAnalysis/securities/fundingLiquidity/FundingLiquidityTable'
import { postFundingLiquidity } from '../../../../companyAnalysis/industry/industryAnalysis/securities/fundingLiquidity/store/thunk'
import { selectIndustryAnalysisState } from '../../../../companyAnalysis/industry/industryAnalysis/store/slice'
import { getUnique } from '../../../../helpers/common'
import { COMPANY_TYPES } from '../../../../utils/common'
import {
  MAIN_SCREEN,
  SCREEN,
  TYPE_INFORMATION_PANEL,
  TYPE_ITEM_SETTING,
  VIEW_BY,
} from '../../constant'
import { mapThunkCommon } from '../thunkCommon'

const PANELS = {
  GENERAL_ANALYSIS: 'generalAnalysis',
  SECTOR_PERFORMANCE_ANALYSIS: 'sectorPerformanceAnalysis',
  LIQUIDITY_SOLVENCY_AND_COVERAGE_CORP: 'liquiditySolvencyAndCoverageCorp',
  ASSET_MANAGEMENT_EFFICIENCY_CORP: 'assetManagementEfficiencyCorp',
  PROFITABILITY_CORP: 'profitabilityCorp',
  BUSINESS_GROWTH_CORP: 'businessGrowthCorp',
  CAPITAL_ADEQUACY_BANK: 'capitalAdequacyBank',
  ASSET_QUALITY_BANK: 'assetQualityBank',
  EARNINGS_QUALITY_BANK: 'earningsQualityBank',
  FUNDING_AND_LIQUIDITY_BANK: 'fundingAndLiquidityBank',
  BUSINESS_GROWTH_BANK: 'businessGrowthBank',
  BUSINESS_POSITION_SEC: 'businessPositionSec',
  CAPITAL_EARNING_AND_LEVERAGE_SEC: 'capitalEarningAndLeverageSec',
  FUNDING_AND_LIQUIDITY_SEC: 'fundingAndLiquiditySec',
}

export const DEFAULT_INDUSTRY = 'DEFAULT_INDUSTRY'
export const COMPARE_INDUSTRY = 'COMPARE_INDUSTRY'

const KEY_DATA = {
  VALUE_1: 'value1',
  VALUE_2: 'value2',
  NET_REVENUE_GROWTH: 'rT0156',
  NET_PROFIT_MARGIN: 'rT2002',
  ROA: 'rT2003',
  TOTAL_DEBT_TO_TOTAL_EQUITY: 'rT0027',
  CURRENT_RATIO: 'rT0020',
}

export const getPanelListIndustryAnalysis = (companyType) => {
  const getChildren = () => {
    switch (companyType) {
      case COMPANY_TYPES.CORPORATE:
        return [
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].INDUSTRY_ANALYSIS,
            panel: PANELS.GENERAL_ANALYSIS,
            label: 'companyAnalysis.industryAnalysis.GENERAL_ANALYSIS',
            type: TYPE_ITEM_SETTING.PANEL,
            setting: {
              viewBy: VIEW_BY.TABLE,
              [DEFAULT_INDUSTRY]: undefined,
              [COMPARE_INDUSTRY]: undefined,
              check: ['isPerformanceMatrix', 'isDistributionOfScore'],
              radio: 'financialRatiosRadio',
            },
          },
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].INDUSTRY_ANALYSIS,
            panel: PANELS.SECTOR_PERFORMANCE_ANALYSIS,
            label:
              'companyAnalysis.industryAnalysis.SECTOR_PERFORMANCE_ANALYSIS',
            type: TYPE_ITEM_SETTING.PANEL,
            setting: {
              viewBy: VIEW_BY.CHART,
              [DEFAULT_INDUSTRY]: undefined,
              [COMPARE_INDUSTRY]: undefined,
              compareBetweenRatio: COMPARE_TYPE.FDI_DOMESTIC,
              childrenRadio: 'sizeRadio',
              childrenChecked: ['sizeChecked', 'nocChecked', 'ratioChecked'],
              sizeChecked: ['isTotalAssets', 'isTotalRevenue', 'isTotalDebt'],
              ratioChecked: [
                KEY_DATA.VALUE_1,
                KEY_DATA.VALUE_2,
                KEY_DATA.NET_REVENUE_GROWTH,
                KEY_DATA.NET_PROFIT_MARGIN,
                KEY_DATA.ROA,
                KEY_DATA.TOTAL_DEBT_TO_TOTAL_EQUITY,
                KEY_DATA.CURRENT_RATIO,
              ],
            },
          },
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].INDUSTRY_ANALYSIS,
            panel: PANELS.LIQUIDITY_SOLVENCY_AND_COVERAGE_CORP,
            label: 'dynamicReport.LIQUIDITY_SOLVENCY_AND_COVERAGE',
            type: TYPE_ITEM_SETTING.PANEL,
            setting: {
              [DEFAULT_INDUSTRY]: undefined,
              [COMPARE_INDUSTRY]: undefined,
            },
          },
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].INDUSTRY_ANALYSIS,
            panel: PANELS.ASSET_MANAGEMENT_EFFICIENCY_CORP,
            label: 'dynamicReport.ASSET_MANAGEMENT_EFFICIENCY',
            type: TYPE_ITEM_SETTING.PANEL,
            setting: {
              [DEFAULT_INDUSTRY]: undefined,
              [COMPARE_INDUSTRY]: undefined,
            },
          },
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].INDUSTRY_ANALYSIS,
            panel: PANELS.PROFITABILITY_CORP,
            label: 'dynamicReport.PROFITABILITY',
            type: TYPE_ITEM_SETTING.PANEL,
            setting: {
              [DEFAULT_INDUSTRY]: undefined,
              [COMPARE_INDUSTRY]: undefined,
            },
          },
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].INDUSTRY_ANALYSIS,
            panel: PANELS.BUSINESS_GROWTH_CORP,
            label: 'dynamicReport.BUSINESS_GROWTH',
            type: TYPE_ITEM_SETTING.PANEL,
            setting: {
              [DEFAULT_INDUSTRY]: undefined,
              [COMPARE_INDUSTRY]: undefined,
            },
          },
        ]
      case COMPANY_TYPES.BANK:
        return [
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].INDUSTRY_ANALYSIS,
            panel: PANELS.CAPITAL_ADEQUACY_BANK,
            label: 'dynamicReport.CAPITAL_ADEQUACY',
            type: TYPE_ITEM_SETTING.PANEL,
          },
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].INDUSTRY_ANALYSIS,
            panel: PANELS.ASSET_QUALITY_BANK,
            label: 'dynamicReport.ASSET_QUALITY',
            type: TYPE_ITEM_SETTING.PANEL,
          },
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].INDUSTRY_ANALYSIS,
            panel: PANELS.EARNINGS_QUALITY_BANK,
            label: 'dynamicReport.EARNINGS_QUALITY',
            type: TYPE_ITEM_SETTING.PANEL,
          },
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].INDUSTRY_ANALYSIS,
            panel: PANELS.FUNDING_AND_LIQUIDITY_BANK,
            label: 'dynamicReport.FUNDING_AND_LIQUIDITY',
            type: TYPE_ITEM_SETTING.PANEL,
          },
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].INDUSTRY_ANALYSIS,
            panel: PANELS.BUSINESS_GROWTH_BANK,
            label: 'dynamicReport.BUSINESS_GROWTH',
            type: TYPE_ITEM_SETTING.PANEL,
          },
        ]
      case COMPANY_TYPES.SECURITIES:
        return [
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].INDUSTRY_ANALYSIS,
            panel: PANELS.BUSINESS_POSITION_SEC,
            label: 'dynamicReport.BUSINESS_POSITION',
            type: TYPE_ITEM_SETTING.PANEL,
          },
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].INDUSTRY_ANALYSIS,
            panel: PANELS.CAPITAL_EARNING_AND_LEVERAGE_SEC,
            label: 'dynamicReport.CAPITAL_EARNING_AND_LEVERAGE',
            type: TYPE_ITEM_SETTING.PANEL,
          },
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].INDUSTRY_ANALYSIS,
            panel: PANELS.FUNDING_AND_LIQUIDITY_SEC,
            label: 'dynamicReport.FUNDING_AND_LIQUIDITY',
            type: TYPE_ITEM_SETTING.PANEL,
          },
        ]
      default:
        return []
    }
  }

  return [
    {
      label: 'dynamicReport.INDUSTRY_ANALYSIS',
      children: [...getChildren()],
    },
  ]
}

export const getPanelIndustryAnalysis = (
  panel,
  {
    performanceScorePeriod,
    creditRiskScorePeriod,
    check = [],
    radio = '',
    viewBy,
    compareBetweenRatio,
    ...others
  },
  companyType,
) => {
  const {
    [DEFAULT_INDUSTRY]: defaultIndustryId,
    [COMPARE_INDUSTRY]: compareIndustryId,
  } = others

  switch (panel) {
    case PANELS.GENERAL_ANALYSIS:
      return {
        renderComponent: () => {
          return (
            <GeneralAnalysisExport
              isDynamicReport
              settingDynamic={{
                check,
                viewBy,
                radio,
                ...others,
              }}
            />
          )
        },
        dependThunks: [mapThunkCommon.ALL_VSICS],
        thunk: [
          () =>
            getGenericRatioHighlight({
              VsicId: defaultIndustryId,
              CompareVsicId: compareIndustryId,
            }),
          radio === 'financialRatiosRadio' && viewBy === VIEW_BY.TABLE
            ? () =>
                getIndustryRatioDetail({
                  MainVsicId: defaultIndustryId,
                  CompareVsicId: compareIndustryId,
                })
            : null,
          radio === 'financialRatiosRadio' && viewBy === VIEW_BY.TABLE
            ? () =>
                getActivitiesRatioAndRisk({
                  MainVsicId: defaultIndustryId,
                })
            : null,
          radio === 'financialRatiosRadio' &&
          viewBy === VIEW_BY.TABLE &&
          compareIndustryId
            ? () =>
                getActivitiesRatioAndRiskCompare({
                  MainVsicId: defaultIndustryId,
                  CompareVsicId: compareIndustryId,
                })
            : null,
          check.includes('isDistributionOfScore') && viewBy === VIEW_BY.CHART
            ? () =>
                getDistributeScoreChart({
                  MainVsicId: defaultIndustryId,
                })
            : null,
          check.includes('isDistributionOfScore') &&
          viewBy === VIEW_BY.CHART &&
          compareIndustryId
            ? () =>
                getDistributeScoreCompareChart({
                  MainVsicId: defaultIndustryId,
                  CompareVsicId: compareIndustryId,
                })
            : null,
          radio === 'commentaryRadio' && viewBy === VIEW_BY.TABLE
            ? () =>
                getCommentary({
                  MainVsicId: defaultIndustryId,
                  CompareVsicId: compareIndustryId,
                })
            : null,
          check.includes('isPerformanceMatrix') && viewBy === VIEW_BY.CHART
            ? () =>
                getPerformanMatrixChartData({
                  MainVsicId: defaultIndustryId,
                  CompareVsicId: compareIndustryId,
                })
            : null,
          check.includes('isPerformanceMatrix') && viewBy === VIEW_BY.CHART
            ? () =>
                getPerformanMatrixDisplayData({
                  MainVsicId: defaultIndustryId,
                  CompareVsicId: compareIndustryId,
                })
            : null,
        ],
        isWaitForMount:
          (viewBy === VIEW_BY.TABLE && radio === 'commentaryRadio') ||
          (viewBy === VIEW_BY.CHART &&
            check.includes('isPerformanceMatrix') &&
            !check.includes('isDistributionOfScore'))
            ? false
            : true,
        settingPanel: {
          viewByList: [VIEW_BY.CHART, VIEW_BY.TABLE],
          [VIEW_BY.TABLE]: getPanelSettingGeneralAnalysis(
            companyType,
            VIEW_BY.TABLE,
          ),
          [VIEW_BY.CHART]: getPanelSettingGeneralAnalysis(
            companyType,
            VIEW_BY.CHART,
          ),
        },
      }
    case PANELS.SECTOR_PERFORMANCE_ANALYSIS:
      return {
        renderComponent: () => {
          return (
            <SectorPerformanceExport
              settingDynamic={{
                viewBy,
                compareBetweenRatio,
                ...others,
              }}
            />
          )
        },
        dependThunks: [mapThunkCommon.ALL_VSICS],
        thunk: [
          compareBetweenRatio === COMPARE_TYPE.LARGE_SME
            ? ({ companyInfo }) =>
                getLargeSme({
                  DefaultVSICId: defaultIndustryId,
                  CompareVSICId: compareIndustryId,
                  OrganizationId: companyInfo.organizationId,
                })
            : undefined,
          compareBetweenRatio === COMPARE_TYPE.LISTED_LARGE
            ? ({ companyInfo }) =>
                getListedLarge({
                  DefaultVSICId: defaultIndustryId,
                  CompareVSICId: compareIndustryId,
                  OrganizationId: companyInfo.organizationId,
                })
            : undefined,
          compareBetweenRatio === COMPARE_TYPE.FDI_DOMESTIC
            ? ({ companyInfo }) =>
                getFdiDomestic({
                  DefaultVSICId: defaultIndustryId,
                  CompareVSICId: compareIndustryId,
                  OrganizationId: companyInfo.organizationId,
                })
            : undefined,
        ],
        isWaitForMount:
          viewBy === VIEW_BY.CHART &&
          others.childrenChecked.length === 1 &&
          others.childrenChecked.includes('nocChecked')
            ? false
            : true,
        isTable: viewBy === VIEW_BY.TABLE,
        settingPanel: {
          viewByList: [VIEW_BY.CHART, VIEW_BY.TABLE],
          [VIEW_BY.CHART]: getPanelSettingSectorPerformanceChart(companyType),
          [VIEW_BY.TABLE]: getPanelSettingSectorPerformanceTable(companyType),
        },
      }
    case PANELS.LIQUIDITY_SOLVENCY_AND_COVERAGE_CORP:
      return {
        renderComponent: () => {
          return <LiquiditySolvencyCoverageTable isDynamicReport />
        },
        dependThunks: [mapThunkCommon.ALL_VSICS],
        thunk: [
          ({ companyInfo, commonData }) =>
            postLiquidityAndSolvencyAndCoverAge({
              isDynamicReport: true,
              vsics: commonData[mapThunkCommon.ALL_VSICS]?.value?.payload,
              companyInfo,
              defaultIndustryId,
              compareIndustryId,
            }),
        ],
        isWaitForMount: true,
        isTable: true,
        settingPanel: {
          items: [
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: ({ key, ...other }) => {
                return (
                  <DefaultIndustry
                    isDynamicReport
                    inputStyle={{ backgroundColor: '#F3F3F3' }}
                    keySetting={DEFAULT_INDUSTRY}
                    {...other}
                  />
                )
              },
            },
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: ({ key, ...other }) => (
                <CompareIndustry
                  isDynamicReport
                  inputStyle={{ backgroundColor: '#F3F3F3' }}
                  keySetting={COMPARE_INDUSTRY}
                  {...other}
                />
              ),
            },
          ],
        },
      }
    case PANELS.ASSET_MANAGEMENT_EFFICIENCY_CORP:
      return {
        renderComponent: () => {
          return <AssetManagementEfficiencyTable isDynamicReport />
        },
        dependThunks: [mapThunkCommon.ALL_VSICS],
        thunk: [
          ({ companyInfo, commonData }) =>
            postAssetManagementEfficiency({
              isDynamicReport: true,
              vsics: commonData[mapThunkCommon.ALL_VSICS]?.value?.payload,
              companyInfo,
              defaultIndustryId,
              compareIndustryId,
            }),
        ],
        isWaitForMount: true,
        isTable: true,
        settingPanel: {
          items: [
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: ({ key, ...other }) => (
                <DefaultIndustry
                  isDynamicReport
                  inputStyle={{ backgroundColor: '#F3F3F3' }}
                  keySetting={DEFAULT_INDUSTRY}
                  {...other}
                />
              ),
            },
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: ({ key, ...other }) => (
                <CompareIndustry
                  isDynamicReport
                  inputStyle={{ backgroundColor: '#F3F3F3' }}
                  keySetting={COMPARE_INDUSTRY}
                  {...other}
                />
              ),
            },
          ],
        },
      }
    case PANELS.PROFITABILITY_CORP:
      return {
        renderComponent: () => {
          return <ProfitabilityTable isDynamicReport />
        },
        dependThunks: [mapThunkCommon.ALL_VSICS],
        thunk: [
          ({ companyInfo, commonData }) =>
            postProfitability({
              isDynamicReport: true,
              vsics: commonData[mapThunkCommon.ALL_VSICS]?.value?.payload,
              companyInfo,
              defaultIndustryId,
              compareIndustryId,
            }),
        ],
        isWaitForMount: true,
        isTable: true,
        settingPanel: {
          items: [
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: ({ key, ...other }) => (
                <DefaultIndustry
                  isDynamicReport
                  inputStyle={{ backgroundColor: '#F3F3F3' }}
                  keySetting={DEFAULT_INDUSTRY}
                  {...other}
                />
              ),
            },
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: ({ key, ...other }) => (
                <CompareIndustry
                  isDynamicReport
                  inputStyle={{ backgroundColor: '#F3F3F3' }}
                  keySetting={COMPARE_INDUSTRY}
                  {...other}
                />
              ),
            },
          ],
        },
      }
    case PANELS.BUSINESS_GROWTH_CORP:
      return {
        renderComponent: () => {
          return <BusinessGrowthTable isDynamicReport />
        },
        dependThunks: [mapThunkCommon.ALL_VSICS],
        thunk: [
          ({ companyInfo, commonData }) =>
            postBusinessGrowth({
              isDynamicReport: true,
              vsics: commonData[mapThunkCommon.ALL_VSICS]?.value?.payload,
              companyInfo,
              defaultIndustryId,
              compareIndustryId,
            }),
        ],
        isWaitForMount: true,
        isTable: true,
        settingPanel: {
          items: [
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: ({ key, ...other }) => (
                <DefaultIndustry
                  isDynamicReport
                  inputStyle={{ backgroundColor: '#F3F3F3' }}
                  keySetting={DEFAULT_INDUSTRY}
                  {...other}
                />
              ),
            },
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: ({ key, ...other }) => (
                <CompareIndustry
                  isDynamicReport
                  inputStyle={{ backgroundColor: '#F3F3F3' }}
                  keySetting={COMPARE_INDUSTRY}
                  {...other}
                />
              ),
            },
          ],
        },
      }
    case PANELS.CAPITAL_ADEQUACY_BANK:
      return {
        renderComponent: () => {
          return <CapitalAdequacyTable isDynamicReport />
        },
        thunk: [
          ({ companyInfo = {} }) =>
            postCapitalAdequacy({
              OrganizationId: companyInfo.organizationId,
            }),
        ],
        isWaitForMount: true,
        isTable: true,
      }
    case PANELS.ASSET_QUALITY_BANK:
      return {
        renderComponent: () => {
          return <AssetQualityTable isDynamicReport />
        },
        thunk: [
          ({ companyInfo = {} }) =>
            postAssetQuality({
              OrganizationId: companyInfo.organizationId,
            }),
        ],
        isWaitForMount: true,
        isTable: true,
      }
    case PANELS.EARNINGS_QUALITY_BANK:
      return {
        renderComponent: () => {
          return <EarningQualityTable isDynamicReport />
        },
        thunk: [
          ({ companyInfo = {} }) =>
            postEarningQuality({
              OrganizationId: companyInfo.organizationId,
            }),
        ],
        isWaitForMount: true,
        isTable: true,
      }
    case PANELS.FUNDING_AND_LIQUIDITY_BANK:
      return {
        renderComponent: () => {
          return <LiquidityTable isDynamicReport />
        },
        thunk: [
          ({ companyInfo = {} }) =>
            postLiquidity({
              OrganizationId: companyInfo.organizationId,
            }),
        ],
        isWaitForMount: true,
        isTable: true,
      }
    case PANELS.BUSINESS_GROWTH_BANK:
      return {
        renderComponent: () => {
          return <BusinessGrowthBankTable isDynamicReport />
        },
        thunk: [
          ({ companyInfo = {} }) =>
            getBusinessGrowthBankThunk({
              OrganizationId: companyInfo.organizationId,
            }),
        ],
        isWaitForMount: true,
        isTable: true,
      }
    case PANELS.BUSINESS_POSITION_SEC:
      return {
        renderComponent: () => {
          return <CapitalEarningLeverageTable isDynamicReport />
        },
        thunk: [
          ({ companyInfo = {} }) =>
            postCapitalEarningLeverage({
              OrganizationId: companyInfo.organizationId,
            }),
        ],
        isWaitForMount: true,
        isTable: true,
      }
    case PANELS.CAPITAL_EARNING_AND_LEVERAGE_SEC:
      return {
        renderComponent: () => {
          return <CapitalEarningLeverageTable isDynamicReport />
        },
        thunk: [
          ({ companyInfo = {} }) =>
            postCapitalEarningLeverage({
              OrganizationId: companyInfo.organizationId,
            }),
        ],
        isWaitForMount: true,
        isTable: true,
      }
    case PANELS.FUNDING_AND_LIQUIDITY_SEC:
      return {
        renderComponent: () => {
          return <FundingLiquidityTable isDynamicReport />
        },
        thunk: [
          ({ companyInfo = {} }) =>
            postFundingLiquidity({
              OrganizationId: companyInfo.organizationId,
            }),
        ],
        isWaitForMount: true,
        isTable: true,
      }
    default:
      break
  }
}

export const getDefaultIndustryAnalysis = (companyType) => {
  const scoreIndustryState = selectScoreIndustryAnalysis(store.getState())
  const industryAnalysisState = selectIndustryAnalysisState(store.getState())
  const vsics = selectVsics(store.getState())
  const { mainVsicId } = selectCompanyInfo(store.getState())

  const defaultIAIndustry =
    industryAnalysisState.defaultIndustry ||
    getDefaultVsic(vsics, mainVsicId)?.id

  return getPanelListIndustryAnalysis(companyType)[0].children.map((panel) => ({
    id: getUnique(),
    ...panel,
    setting: {
      ...getSetting(panel, scoreIndustryState),
      [DEFAULT_INDUSTRY]: defaultIAIndustry,
      [COMPARE_INDUSTRY]: industryAnalysisState.compareIndustry,
    },
  }))
}

const getSetting = (panel, state) => {
  switch (panel?.panel) {
    case PANELS.INDUSTRY_MEDIAN_SCORE:
      return {
        ...panel.setting,
        check: [
          state.tab === SCORE_TABS.credit.key
            ? 'isCreditRiskScore'
            : 'isPerformanceScore',
        ],
        creditRiskScorePeriod:
          state.tab === SCORE_TABS.credit.key ? state.period : undefined,
        performanceScorePeriod:
          state.tab === SCORE_TABS.performance.key ? state.period : undefined,
      }

    default:
      return panel.setting
  }
}

const getPanelSettingGeneralAnalysis = (companyType, viewBy) => {
  let result = []
  let resultChart = [
    {
      type: TYPE_INFORMATION_PANEL.CHECKBOX,
      key: 'check',
      value: 'isPerformanceMatrix',
      title: 'companyAnalysis.industryAnalysis.PERFORMANCE_MATRIX',
    },
    {
      type: TYPE_INFORMATION_PANEL.CHECKBOX,
      key: 'check',
      value: 'isDistributionOfScore',
      title: 'companyAnalysis.industryAnalysis.DISTRIBUTION_OF_SCORE',
    },
  ]

  let resultTable = [
    {
      type: TYPE_INFORMATION_PANEL.RADIO,
      value: 'financialRatiosRadio',
      key: 'radio',
      title: 'companyAnalysis.industryAnalysis.FINANCIAL_RATIOS_ACTIVITIES',
    },
    {
      type: TYPE_INFORMATION_PANEL.RADIO,
      value: 'commentaryRadio',
      key: 'radio',
      title: 'companyAnalysis.industryAnalysis.COMMENTARY',
    },
  ]

  if (viewBy === VIEW_BY.CHART) {
    result = resultChart
  } else {
    result = resultTable
  }

  if (companyType === COMPANY_TYPES.CORPORATE) {
    result = [
      {
        type: TYPE_INFORMATION_PANEL.NODE,
        renderItem: ({ key, ...other }) => (
          <DefaultIndustry
            isDynamicReport
            inputStyle={{ backgroundColor: '#F3F3F3' }}
            keySetting={DEFAULT_INDUSTRY}
            {...other}
          />
        ),
      },
      {
        type: TYPE_INFORMATION_PANEL.NODE,
        renderItem: ({ key, ...other }) => (
          <CompareIndustry
            isDynamicReport
            inputStyle={{ backgroundColor: '#F3F3F3' }}
            keySetting={COMPARE_INDUSTRY}
            {...other}
          />
        ),
      },
      ...result,
    ]
  }

  return result
}

const getPanelSettingSectorPerformanceTable = (companyType) => {
  let result = [
    {
      type: TYPE_INFORMATION_PANEL.NODE,
      renderItem: () => (
        <Translate value="companyAnalysis.industryAnalysis.COMPARE_BETWEEN" />
      ),
    },
    {
      type: TYPE_INFORMATION_PANEL.RADIO,
      value: COMPARE_TYPE.FDI_DOMESTIC,
      key: 'compareBetweenRatio',
      title: 'companyAnalysis.industryAnalysis.FDI_DOMESTIC',
      children: [
        {
          type: TYPE_INFORMATION_PANEL.RADIO,
          value: 'sizeRadio',
          key: 'childrenRadio',
          title: 'companyAnalysis.industryAnalysis.SIZE_1',
          children: [
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: 'isTotalAssets',
              key: 'sizeChecked',
              title: 'companyAnalysis.industryAnalysis.TOTAL_ASSETS',
              isBreakLine: true,
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: 'isTotalRevenue',
              key: 'sizeChecked',
              title: 'companyAnalysis.industryAnalysis.TOTAL_REVENUE',
              isBreakLine: true,
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: 'isTotalDebt',
              key: 'sizeChecked',
              title: 'companyAnalysis.industryAnalysis.TOTAL_DEBT',
              isBreakLine: true,
            },
          ],
        },
        {
          type: TYPE_INFORMATION_PANEL.RADIO,
          value: 'nocRadio',
          key: 'childrenRadio',
          title: 'companyAnalysis.industryAnalysis.NUMBER_OF_COMPANIES_1',
        },
        {
          type: TYPE_INFORMATION_PANEL.RADIO,
          value: 'ratioRadio',
          key: 'childrenRadio',
          title: 'companyAnalysis.industryAnalysis.RATIO_COMPARISON_1',
          children: [
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => (
                <Translate value="companyAnalysis.industryAnalysis.SECTOR" />
              ),
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: KEY_DATA.VALUE_1,
              key: 'ratioChecked',
              title: 'companyAnalysis.industryAnalysis.FDI',
              isBreakLine: true,
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: KEY_DATA.VALUE_2,
              key: 'ratioChecked',
              title: 'companyAnalysis.industryAnalysis.DOMESTIC',
              isBreakLine: true,
            },
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => (
                <Translate value="companyAnalysis.industryAnalysis.RATIO_2" />
              ),
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: KEY_DATA.NET_REVENUE_GROWTH,
              key: 'ratioChecked',
              title: 'companyAnalysis.industryAnalysis.NET_REVENUE_GROWTH',
              isBreakLine: true,
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: KEY_DATA.NET_PROFIT_MARGIN,
              key: 'ratioChecked',
              title: 'companyAnalysis.industryAnalysis.NET_PROFIT_MARGIN',
              isBreakLine: true,
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: KEY_DATA.ROA,
              key: 'ratioChecked',
              title: 'companyAnalysis.industryAnalysis.ROA',
              isBreakLine: true,
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: KEY_DATA.TOTAL_DEBT_TO_TOTAL_EQUITY,
              key: 'ratioChecked',
              title:
                'companyAnalysis.industryAnalysis.TOTAL_DEBT_TO_TOTAL_EQUITY',
              isBreakLine: true,
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: KEY_DATA.CURRENT_RATIO,
              key: 'ratioChecked',
              title: 'companyAnalysis.industryAnalysis.CURRENT_RATIO',
              isBreakLine: true,
            },
          ],
        },
      ],
    },
    {
      type: TYPE_INFORMATION_PANEL.RADIO,
      value: COMPARE_TYPE.LARGE_SME,
      key: 'compareBetweenRatio',
      title: 'companyAnalysis.industryAnalysis.LARGE_SME',
      children: [
        {
          type: TYPE_INFORMATION_PANEL.RADIO,
          value: 'sizeRadio',
          key: 'childrenRadio',
          title: 'companyAnalysis.industryAnalysis.SIZE_1',
          children: [
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: 'isTotalAssets',
              key: 'sizeChecked',
              title: 'companyAnalysis.industryAnalysis.TOTAL_ASSETS',
              isBreakLine: true,
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: 'isTotalRevenue',
              key: 'sizeChecked',
              title: 'companyAnalysis.industryAnalysis.TOTAL_REVENUE',
              isBreakLine: true,
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: 'isTotalDebt',
              key: 'sizeChecked',
              title: 'companyAnalysis.industryAnalysis.TOTAL_DEBT',
              isBreakLine: true,
            },
          ],
        },
        {
          type: TYPE_INFORMATION_PANEL.RADIO,
          value: 'nocRadio',
          key: 'childrenRadio',
          title: 'companyAnalysis.industryAnalysis.NUMBER_OF_COMPANIES_1',
        },
        {
          type: TYPE_INFORMATION_PANEL.RADIO,
          value: 'ratioRadio',
          key: 'childrenRadio',
          title: 'companyAnalysis.industryAnalysis.RATIO_COMPARISON_1',
          children: [
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => (
                <Translate value="companyAnalysis.industryAnalysis.SECTOR" />
              ),
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: KEY_DATA.VALUE_1,
              key: 'ratioChecked',
              title: 'companyAnalysis.industryAnalysis.LARGE',
              isBreakLine: true,
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: KEY_DATA.VALUE_2,
              key: 'ratioChecked',
              title: 'companyAnalysis.industryAnalysis.SME',
              isBreakLine: true,
            },
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => (
                <Translate value="companyAnalysis.industryAnalysis.RATIO_2" />
              ),
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: KEY_DATA.NET_REVENUE_GROWTH,
              key: 'ratioChecked',
              title: 'companyAnalysis.industryAnalysis.NET_REVENUE_GROWTH',
              isBreakLine: true,
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: KEY_DATA.NET_PROFIT_MARGIN,
              key: 'ratioChecked',
              title: 'companyAnalysis.industryAnalysis.NET_PROFIT_MARGIN',
              isBreakLine: true,
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: KEY_DATA.ROA,
              key: 'ratioChecked',
              title: 'companyAnalysis.industryAnalysis.ROA',
              isBreakLine: true,
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: KEY_DATA.TOTAL_DEBT_TO_TOTAL_EQUITY,
              key: 'ratioChecked',
              title:
                'companyAnalysis.industryAnalysis.TOTAL_DEBT_TO_TOTAL_EQUITY',
              isBreakLine: true,
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: KEY_DATA.CURRENT_RATIO,
              key: 'ratioChecked',
              title: 'companyAnalysis.industryAnalysis.CURRENT_RATIO',
              isBreakLine: true,
            },
          ],
        },
      ],
    },
    {
      type: TYPE_INFORMATION_PANEL.RADIO,
      value: COMPARE_TYPE.LISTED_LARGE,
      key: 'compareBetweenRatio',
      title: 'companyAnalysis.industryAnalysis.LISTED_LARGE',
      children: [
        {
          type: TYPE_INFORMATION_PANEL.RADIO,
          value: 'sizeRadio',
          key: 'childrenRadio',
          title: 'companyAnalysis.industryAnalysis.SIZE_1',
          children: [
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: 'isTotalAssets',
              key: 'sizeChecked',
              title: 'companyAnalysis.industryAnalysis.TOTAL_ASSETS',
              isBreakLine: true,
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: 'isTotalRevenue',
              key: 'sizeChecked',
              title: 'companyAnalysis.industryAnalysis.TOTAL_REVENUE',
              isBreakLine: true,
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: 'isTotalDebt',
              key: 'sizeChecked',
              title: 'companyAnalysis.industryAnalysis.TOTAL_DEBT',
              isBreakLine: true,
            },
          ],
        },
        {
          type: TYPE_INFORMATION_PANEL.RADIO,
          value: 'nocRadio',
          key: 'childrenRadio',
          title: 'companyAnalysis.industryAnalysis.NUMBER_OF_COMPANIES_1',
        },
        {
          type: TYPE_INFORMATION_PANEL.RADIO,
          value: 'ratioRadio',
          key: 'childrenRadio',
          title: 'companyAnalysis.industryAnalysis.RATIO_COMPARISON_1',
          children: [
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => (
                <Translate value="companyAnalysis.industryAnalysis.SECTOR" />
              ),
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: KEY_DATA.VALUE_1,
              key: 'ratioChecked',
              title: 'companyAnalysis.industryAnalysis.LISTED',
              isBreakLine: true,
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: KEY_DATA.VALUE_2,
              key: 'ratioChecked',
              title: 'companyAnalysis.industryAnalysis.LARGE_PRIVATE',
              isBreakLine: true,
            },
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => (
                <Translate value="companyAnalysis.industryAnalysis.RATIO_2" />
              ),
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: KEY_DATA.NET_REVENUE_GROWTH,
              key: 'ratioChecked',
              title: 'companyAnalysis.industryAnalysis.NET_REVENUE_GROWTH',
              isBreakLine: true,
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: KEY_DATA.NET_PROFIT_MARGIN,
              key: 'ratioChecked',
              title: 'companyAnalysis.industryAnalysis.NET_PROFIT_MARGIN',
              isBreakLine: true,
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: KEY_DATA.ROA,
              key: 'ratioChecked',
              title: 'companyAnalysis.industryAnalysis.ROA',
              isBreakLine: true,
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: KEY_DATA.TOTAL_DEBT_TO_TOTAL_EQUITY,
              key: 'ratioChecked',
              title:
                'companyAnalysis.industryAnalysis.TOTAL_DEBT_TO_TOTAL_EQUITY',
              isBreakLine: true,
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: KEY_DATA.CURRENT_RATIO,
              key: 'ratioChecked',
              title: 'companyAnalysis.industryAnalysis.CURRENT_RATIO',
              isBreakLine: true,
            },
          ],
        },
      ],
    },
  ]

  if (companyType === COMPANY_TYPES.CORPORATE) {
    result = [
      {
        type: TYPE_INFORMATION_PANEL.NODE,
        renderItem: ({ key, ...other }) => (
          <DefaultIndustry
            isDynamicReport
            inputStyle={{ backgroundColor: '#F3F3F3' }}
            keySetting={DEFAULT_INDUSTRY}
            {...other}
          />
        ),
      },
      {
        type: TYPE_INFORMATION_PANEL.NODE,
        renderItem: ({ key, ...other }) => (
          <CompareIndustry
            isDynamicReport
            inputStyle={{ backgroundColor: '#F3F3F3' }}
            keySetting={COMPARE_INDUSTRY}
            {...other}
          />
        ),
      },
      ...result,
    ]
  }

  return result
}

const getPanelSettingSectorPerformanceChart = (companyType) => {
  let result = [
    {
      type: TYPE_INFORMATION_PANEL.NODE,
      renderItem: () => (
        <Translate value="companyAnalysis.industryAnalysis.COMPARE_BETWEEN" />
      ),
    },
    {
      type: TYPE_INFORMATION_PANEL.RADIO,
      value: COMPARE_TYPE.FDI_DOMESTIC,
      key: 'compareBetweenRatio',
      title: 'companyAnalysis.industryAnalysis.FDI_DOMESTIC',
      children: [
        {
          type: TYPE_INFORMATION_PANEL.CHECKBOX,
          value: 'sizeChecked',
          key: 'childrenChecked',
          title: 'companyAnalysis.industryAnalysis.SIZE_1',
          children: [
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: 'isTotalAssets',
              key: 'sizeChecked',
              title: 'companyAnalysis.industryAnalysis.TOTAL_ASSETS',
              isBreakLine: true,
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: 'isTotalRevenue',
              key: 'sizeChecked',
              title: 'companyAnalysis.industryAnalysis.TOTAL_REVENUE',
              isBreakLine: true,
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: 'isTotalDebt',
              key: 'sizeChecked',
              title: 'companyAnalysis.industryAnalysis.TOTAL_DEBT',
              isBreakLine: true,
            },
          ],
        },
        {
          type: TYPE_INFORMATION_PANEL.CHECKBOX,
          value: 'nocChecked',
          key: 'childrenChecked',
          title: 'companyAnalysis.industryAnalysis.NUMBER_OF_COMPANIES_1',
        },
        {
          type: TYPE_INFORMATION_PANEL.CHECKBOX,
          value: 'ratioChecked',
          key: 'childrenChecked',
          title: 'companyAnalysis.industryAnalysis.RATIO_COMPARISON_1',
          children: [
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => (
                <Translate value="companyAnalysis.industryAnalysis.SECTOR" />
              ),
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: KEY_DATA.VALUE_1,
              key: 'ratioChecked',
              title: 'companyAnalysis.industryAnalysis.FDI',
              isBreakLine: true,
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: KEY_DATA.VALUE_2,
              key: 'ratioChecked',
              title: 'companyAnalysis.industryAnalysis.DOMESTIC',
              isBreakLine: true,
            },
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => (
                <Translate value="companyAnalysis.industryAnalysis.RATIO_2" />
              ),
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: KEY_DATA.NET_REVENUE_GROWTH,
              key: 'ratioChecked',
              title: 'companyAnalysis.industryAnalysis.NET_REVENUE_GROWTH',
              isBreakLine: true,
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: KEY_DATA.NET_PROFIT_MARGIN,
              key: 'ratioChecked',
              title: 'companyAnalysis.industryAnalysis.NET_PROFIT_MARGIN',
              isBreakLine: true,
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: KEY_DATA.ROA,
              key: 'ratioChecked',
              title: 'companyAnalysis.industryAnalysis.ROA',
              isBreakLine: true,
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: KEY_DATA.TOTAL_DEBT_TO_TOTAL_EQUITY,
              key: 'ratioChecked',
              title:
                'companyAnalysis.industryAnalysis.TOTAL_DEBT_TO_TOTAL_EQUITY',
              isBreakLine: true,
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: KEY_DATA.CURRENT_RATIO,
              key: 'ratioChecked',
              title: 'companyAnalysis.industryAnalysis.CURRENT_RATIO',
              isBreakLine: true,
            },
          ],
        },
      ],
    },
    {
      type: TYPE_INFORMATION_PANEL.RADIO,
      value: COMPARE_TYPE.LARGE_SME,
      key: 'compareBetweenRatio',
      title: 'companyAnalysis.industryAnalysis.LARGE_SME',
      children: [
        {
          type: TYPE_INFORMATION_PANEL.CHECKBOX,
          value: 'sizeChecked',
          key: 'childrenChecked',
          title: 'companyAnalysis.industryAnalysis.SIZE_1',
          children: [
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: 'isTotalAssets',
              key: 'sizeChecked',
              title: 'companyAnalysis.industryAnalysis.TOTAL_ASSETS',
              isBreakLine: true,
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: 'isTotalRevenue',
              key: 'sizeChecked',
              title: 'companyAnalysis.industryAnalysis.TOTAL_REVENUE',
              isBreakLine: true,
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: 'isTotalDebt',
              key: 'sizeChecked',
              title: 'companyAnalysis.industryAnalysis.TOTAL_DEBT',
              isBreakLine: true,
            },
          ],
        },
        {
          type: TYPE_INFORMATION_PANEL.CHECKBOX,
          value: 'nocChecked',
          key: 'childrenChecked',
          title: 'companyAnalysis.industryAnalysis.NUMBER_OF_COMPANIES_1',
        },
        {
          type: TYPE_INFORMATION_PANEL.CHECKBOX,
          value: 'ratioChecked',
          key: 'childrenChecked',
          title: 'companyAnalysis.industryAnalysis.RATIO_COMPARISON_1',
          children: [
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => (
                <Translate value="companyAnalysis.industryAnalysis.SECTOR" />
              ),
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: KEY_DATA.VALUE_1,
              key: 'ratioChecked',
              title: 'companyAnalysis.industryAnalysis.LARGE',
              isBreakLine: true,
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: KEY_DATA.VALUE_2,
              key: 'ratioChecked',
              title: 'companyAnalysis.industryAnalysis.SME',
              isBreakLine: true,
            },
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => (
                <Translate value="companyAnalysis.industryAnalysis.RATIO_2" />
              ),
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: KEY_DATA.NET_REVENUE_GROWTH,
              key: 'ratioChecked',
              title: 'companyAnalysis.industryAnalysis.NET_REVENUE_GROWTH',
              isBreakLine: true,
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: KEY_DATA.NET_PROFIT_MARGIN,
              key: 'ratioChecked',
              title: 'companyAnalysis.industryAnalysis.NET_PROFIT_MARGIN',
              isBreakLine: true,
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: KEY_DATA.ROA,
              key: 'ratioChecked',
              title: 'companyAnalysis.industryAnalysis.ROA',
              isBreakLine: true,
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: KEY_DATA.TOTAL_DEBT_TO_TOTAL_EQUITY,
              key: 'ratioChecked',
              title:
                'companyAnalysis.industryAnalysis.TOTAL_DEBT_TO_TOTAL_EQUITY',
              isBreakLine: true,
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: KEY_DATA.CURRENT_RATIO,
              key: 'ratioChecked',
              title: 'companyAnalysis.industryAnalysis.CURRENT_RATIO',
              isBreakLine: true,
            },
          ],
        },
      ],
    },
    {
      type: TYPE_INFORMATION_PANEL.RADIO,
      value: COMPARE_TYPE.LISTED_LARGE,
      key: 'compareBetweenRatio',
      title: 'companyAnalysis.industryAnalysis.LISTED_LARGE',
      children: [
        {
          type: TYPE_INFORMATION_PANEL.CHECKBOX,
          value: 'sizeChecked',
          key: 'childrenChecked',
          title: 'companyAnalysis.industryAnalysis.SIZE_1',
          children: [
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: 'isTotalAssets',
              key: 'sizeChecked',
              title: 'companyAnalysis.industryAnalysis.TOTAL_ASSETS',
              isBreakLine: true,
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: 'isTotalRevenue',
              key: 'sizeChecked',
              title: 'companyAnalysis.industryAnalysis.TOTAL_REVENUE',
              isBreakLine: true,
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: 'isTotalDebt',
              key: 'sizeChecked',
              title: 'companyAnalysis.industryAnalysis.TOTAL_DEBT',
              isBreakLine: true,
            },
          ],
        },
        {
          type: TYPE_INFORMATION_PANEL.CHECKBOX,
          value: 'nocChecked',
          key: 'childrenChecked',
          title: 'companyAnalysis.industryAnalysis.NUMBER_OF_COMPANIES_1',
        },
        {
          type: TYPE_INFORMATION_PANEL.CHECKBOX,
          value: 'ratioChecked',
          key: 'childrenChecked',
          title: 'companyAnalysis.industryAnalysis.RATIO_COMPARISON_1',
          children: [
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => (
                <Translate value="companyAnalysis.industryAnalysis.SECTOR" />
              ),
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: KEY_DATA.VALUE_1,
              key: 'ratioChecked',
              title: 'companyAnalysis.industryAnalysis.LISTED',
              isBreakLine: true,
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: KEY_DATA.VALUE_2,
              key: 'ratioChecked',
              title: 'companyAnalysis.industryAnalysis.LARGE_PRIVATE',
              isBreakLine: true,
            },
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => (
                <Translate value="companyAnalysis.industryAnalysis.RATIO_2" />
              ),
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: KEY_DATA.NET_REVENUE_GROWTH,
              key: 'ratioChecked',
              title: 'companyAnalysis.industryAnalysis.NET_REVENUE_GROWTH',
              isBreakLine: true,
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: KEY_DATA.NET_PROFIT_MARGIN,
              key: 'ratioChecked',
              title: 'companyAnalysis.industryAnalysis.NET_PROFIT_MARGIN',
              isBreakLine: true,
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: KEY_DATA.ROA,
              key: 'ratioChecked',
              title: 'companyAnalysis.industryAnalysis.ROA',
              isBreakLine: true,
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: KEY_DATA.TOTAL_DEBT_TO_TOTAL_EQUITY,
              key: 'ratioChecked',
              title:
                'companyAnalysis.industryAnalysis.TOTAL_DEBT_TO_TOTAL_EQUITY',
              isBreakLine: true,
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              value: KEY_DATA.CURRENT_RATIO,
              key: 'ratioChecked',
              title: 'companyAnalysis.industryAnalysis.CURRENT_RATIO',
              isBreakLine: true,
            },
          ],
        },
      ],
    },
  ]

  if (companyType === COMPANY_TYPES.CORPORATE) {
    result = [
      {
        type: TYPE_INFORMATION_PANEL.NODE,
        renderItem: ({ key, ...other }) => (
          <DefaultIndustry
            isDynamicReport
            inputStyle={{ backgroundColor: '#F3F3F3' }}
            keySetting={DEFAULT_INDUSTRY}
            {...other}
          />
        ),
      },
      {
        type: TYPE_INFORMATION_PANEL.NODE,
        renderItem: ({ key, ...other }) => (
          <CompareIndustry
            isDynamicReport
            inputStyle={{ backgroundColor: '#F3F3F3' }}
            keySetting={COMPARE_INDUSTRY}
            {...other}
          />
        ),
      },
      ...result,
    ]
  }

  return result
}
